<html>
<body>
  <div class="container-fluid divParent">
    <div class="col-sm-12 divChild">
      <mat-toolbar  class="login-toolbar">
      </mat-toolbar> 

      <br>

      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-10 bg-color-card">

            <div class="col-md-12">     
            <h1 class="login-header">Forgot Password</h1>
            <p class="login-sub-header">Enter below requsted details and  we'll send a link to reset your password</p>

            <form  [formGroup] ="loginForm" (ngSubmit)="onSubmit()">  

                <div class="form-group">
                    <label for="email" class="col-form-label labelColor"> Your Email Address</label>
                    <div class="input-group">
                    <input type="text" formControlName="email" class="form-control form-control-lg dark-input-field"  [class.is-invalid]="formErrors.email" (blur)="logValidationErrors()" placeholder="Email Address">                   
                  </div>
                  <span class="text-danger" *ngIf="formErrors.email"><small>{{formErrors.email}}</small> </span> 
                </div>   

                  <div class="form-group">
                    <label for="username" class="col-form-label labelColor">Username</label>
                    <div class="input-group">
                    <input type="text" formControlName="username" class="form-control form-control-lg dark-input-field"  [class.is-invalid]="formErrors.username" (blur)="logValidationErrors()" placeholder="Username">                   
                  </div>
                  <span class="text-danger" *ngIf="formErrors.username"><small>{{formErrors.username}}</small> </span> 
                </div>         
                  
                  <br>
                  
                  <button [disabled]="!loginForm.valid" 
                   [ngClass]="{'loginBtnActive' : loginForm.valid,'loginBtnDisabled' : !loginForm.valid }"
                    type="submit" class="btn btn-lg btn-block">
                  <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                   REQUEST PASSWORD
                  </button>
        
                  <br>
                  <div class="row">
                    <div class="col-8">
                        <a routerLink="/login"  class="labelColor">Back to Log In</a>
                    </div>
                  </div> 
           
            </form> 
          </div>

            </div>      
          </div>

     
    </div>
</div>
</body>
</html>





  

    
          <!-- user Login : {{ userLoginForm.value | json }} -->

